export default __webpack_public_path__ + "static/media/sn-gensen.28eae727.jpg";